<template>
  <main class="public-page-shell">
    <!-- 公共页面沿用地面站的网格背景、环境光与品牌标识。 -->
    <div class="public-page-grid" aria-hidden="true"></div>
    <div class="public-page-glow public-page-glow-primary" aria-hidden="true"></div>
    <div class="public-page-glow public-page-glow-warning" aria-hidden="true"></div>
    <header class="public-page-brand">
      <span class="public-page-logo" :style="{ '--public-page-logo': `url(${logo})` }" aria-hidden="true"></span>
      <span class="public-page-brand-copy">
        <span class="public-page-brand-title">
          <strong>{{ appName }}</strong>
          <em>{{ appVersion }}</em>
        </span>
        <small>{{ $t("无人机地面站") }}</small>
      </span>
    </header>
    <slot />
  </main>
</template>

<script>
import logo from '@/assets/logo.svg'

export default {
  name: 'PublicPageShell',
  data () {
    return { logo }
  },
  computed: {
    appName () { return this.$store.state.settings.appName },
    appVersion () { return this.$store.state.settings.appVersion }
  }
}
</script>

<style lang="scss" scoped>
.public-page-shell { min-height: 100%; position: relative; display: grid; place-items: center; padding: calc(var(--ui-space-lg) * 4) calc(var(--ui-space-md) * 2) calc(var(--ui-space-md) * 2); overflow: hidden; box-sizing: border-box; color: var(--ui-text-primary); background: radial-gradient(circle at 50% 42%, rgba(var(--ui-bg-elevated-rgb), .52), transparent 52%), var(--ui-bg-page); }
.public-page-grid { position: absolute; inset: 0; opacity: .3; pointer-events: none; background-image: linear-gradient(rgba(var(--ui-text-regular-rgb), .035) 1px, transparent 1px), linear-gradient(90deg, rgba(var(--ui-text-regular-rgb), .035) 1px, transparent 1px); background-size: calc(var(--ui-space-md) * 2) calc(var(--ui-space-md) * 2); mask-image: linear-gradient(to bottom, transparent, var(--ui-color-black) 16%, var(--ui-color-black) 82%, transparent); }
.public-page-grid::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, transparent, rgba(var(--ui-color-primary-rgb), .035), transparent); animation: public-page-scan 7s linear infinite; }
.public-page-glow { width: 38vw; height: 38vw; position: absolute; border-radius: 50%; opacity: .055; pointer-events: none; filter: blur(90px); }
.public-page-glow-primary { top: -22vw; right: -12vw; background: var(--ui-color-primary); }
.public-page-glow-warning { bottom: -28vw; left: -18vw; background: var(--ui-color-warning); }
.public-page-brand { height: 52px; position: absolute; top: var(--ui-space-md); left: var(--ui-space-lg); z-index: 2; display: flex; align-items: center; gap: var(--ui-space-sm); }
.public-page-logo { width: 34px; height: 34px; flex: none; background: var(--ui-color-primary); -webkit-mask: var(--public-page-logo) center / contain no-repeat; mask: var(--public-page-logo) center / contain no-repeat; }
.public-page-brand-copy { display: grid; gap: 4px; min-width: 0; }
.public-page-brand-title { display: flex; align-items: baseline; gap: var(--ui-space-sm); white-space: nowrap; }
.public-page-brand-copy strong { color: var(--ui-text-primary); font-size: 16px; font-weight: 700; letter-spacing: .8px; line-height: 1; }
.public-page-brand-title em { color: var(--ui-text-disabled); font-family: var(--ui-font-mono); font-size: 11px; font-style: normal; font-weight: 500; letter-spacing: .2px; }
.public-page-brand-copy small { color: var(--ui-text-secondary); font-size: 12px; letter-spacing: 1.6px; line-height: 1; }
@keyframes public-page-scan { from { transform: translateX(-100%); } to { transform: translateX(100%); } }
@media (max-width: 640px) {
  .public-page-shell { padding: calc(var(--ui-space-lg) * 4) var(--ui-space-md) var(--ui-space-lg); }
  .public-page-brand { top: var(--ui-space-sm); left: var(--ui-space-md); }
}
@media (orientation: landscape) and (max-height: 640px) {
  .public-page-shell { padding: 12px 50px; }
  .public-page-brand {
    height: 38px;
    top: 10px;
    left: 12px;
    transform: none;
  }
  .public-page-logo { width: 28px; height: 28px; }
  .public-page-brand-copy { display: block; }
  .public-page-brand-title em,
  .public-page-brand-copy small { display: none; }
}
@media (orientation: landscape) and (max-height: 420px) {
  .public-page-shell { padding: 10px 46px; }
  .public-page-brand { top: 8px; left: 8px; }
  .public-page-brand-copy { display: none; }
}
</style>
